<template>
  <v-container id="dashboard" fluid>
    <v-row>
      <v-col cols="12">
        <div class="d-flex justify-center">
          <v-subheader class="display-1 font-weight-bold has-border">Promotion</v-subheader>
        </div>
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="4">
        <router-link :to="{ name: 'studentPromotionList' }" title="Student Promotion">
          <clickable-card gotoIcon="mdi-arrow-top-right" icon="mdi-account-tie" color="pink" cardTitle="Student Promotion"> </clickable-card>
        </router-link>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ClickableCard from '@/components/template/ClickableCard'
export default {
  components: { ClickableCard },
  name: 'nodalLedger',
  data () {
    return {}
  }
}
</script>
